import React, { forwardRef } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { TextArea } from "@progress/kendo-react-inputs";

/**
 * DKNInput — Daikin design system single-line text input.
 * Wraps Kendo Input with project-wide defaults.
 *
 * Props (all Kendo Input props forwarded):
 *   label       string
 *   error       string — shows red helper text below
 *   fullWidth   boolean (default: false)
 */
export const DKNInput = forwardRef(function DKNInput(
  { label, error, fullWidth = false, className = "", style, ...rest },
  ref
) {
  return (
    <div
      className={`dkn-input-wrap${fullWidth ? " dkn-input-full" : ""}${error ? " dkn-input-error" : ""} ${className}`}
      style={style}
    >
      {label && <label className="dkn-input-label">{label}</label>}
      <Input
        ref={ref}
        className={`dkn-input${error ? " dkn-input-invalid" : ""}`}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

/**
 * DKNTextArea — Daikin design system multi-line text input.
 * Wraps Kendo TextArea with project-wide defaults.
 *
 * Props (all Kendo TextArea props forwarded):
 *   label       string
 *   error       string — shows red helper text below
 *   fullWidth   boolean (default: false)
 *   rows        number  (default: 3)
 */
export const DKNTextArea = forwardRef(function DKNTextArea(
  { label, error, fullWidth = false, rows = 3, className = "", style, ...rest },
  ref
) {
  return (
    <div
      className={`dkn-input-wrap${fullWidth ? " dkn-input-full" : ""}${error ? " dkn-input-error" : ""} ${className}`}
      style={style}
    >
      {label && <label className="dkn-input-label">{label}</label>}
      <TextArea
        ref={ref}
        rows={rows}
        autoSize
        className={`dkn-input${error ? " dkn-input-invalid" : ""}`}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

export default DKNInput;
